import React from 'react';
import ChrWidget from '../../../generic/PageUI/Compound/ChrWidget';
import MembershipApplicationsBody from './body'
import { getDefaultWidgetConfigs, getRemoteConfigs } from '../utils';
import { getCommonDateRangeWithPresetFilterValue } from '../../../generic/Utils/commonUtils';
import useWidgetActionsBuilder from '../../../../hooks/generic/Actions/useWidgetActionsBuilder';
import { getEventDetailsForDateFilter } from '../../../generic/Actions/WidgetActions/DateFilter/utils';
import { getEventDetailsHash } from '../utils';

/*
props = {
  data: {
    uId: <uniqueIdentifier>,
    name: <string>,
    className: <string>,
    url: <string>
  }
}
*/

export const exportEventName = "membershipApplicationsExportChart";

const MembershipApplications = (props) => {
  const { name, url, actionsData } = props;
  const defaultWidgetConfigs = getDefaultWidgetConfigs(props);
  const filterKey = 'applicationsSent';

  const configBuilder = (state) => {
    return {
      remoteOptions: getRemoteConfigs(url, MembershipApplicationsBody, { filters: getCommonDateRangeWithPresetFilterValue(state, filterKey, 'applications_sent_date_range') })
    };
  }

  const eventDetailsBuilder = (state) => {
    const { eventName, dateRange, preset } = getEventDetailsForDateFilter(state, { filterKey })

    return getEventDetailsHash({ eventName, source: name, dateRange, preset, eventCategory: props.eventCategory });
  }

  const { actions, widgetConfig } = useWidgetActionsBuilder(actionsData, configBuilder, { exportEventName, eventDetailsBuilder });

  return (
    <ChrWidget
      { ...defaultWidgetConfigs }
      header={ name }
      headerActions={ actions.headerActions }
      footerActions={ actions.footerActions }
      { ...widgetConfig.remoteOptions }
      footerActionsClass='px-1'
    />
  );
};

export default MembershipApplications;
